import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlarmOverview } from '../../interfaces/alarm';
import { TileComponent } from '../../../../../shared/src/lib/components/tile/tile.component';

import { IconButtonComponent } from '../../../../../shared/src/lib/components/icon-button/icon-button.component';
import { AlarmTableComponent } from '../alarms/alarm-table/alarm-table.component';
import { TileFooterComponent } from '../../../../../shared/src/lib/components/tile-footer/tile-footer.component';
import { Angulartics2OnModule } from 'angulartics2';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-installation-system-status',
    templateUrl: './installation-system-status.component.html',
    styleUrls: ['./installation-system-status.component.scss'],
    imports: [TileComponent, IconButtonComponent, AlarmTableComponent, TileFooterComponent, Angulartics2OnModule, TranslateModule]
})
export class InstallationSystemStatusComponent {

  @Input()
  public showSettings: boolean = false;

  @Output()
  public alarmClick = new EventEmitter<AlarmOverview>();

  @Output()
  public settingsClick = new EventEmitter<void>();

  @Output()
  public showAllAlarms = new EventEmitter<void>();

  public alarmFilter: (alarm: AlarmOverview) => boolean = alarm => {
    const activation = alarm.currentActivation;
    return !activation.clearedTimestampEpoch;
  };
}
